<app-alt-nav-bar></app-alt-nav-bar>
<section
  id="#scroll-section"
  class="w-screen flex flex-col justify-center items-center text-primary-default"
>
  <div class="w-full py-14 md:py-24">
    <div
      class="w-full flex flex-col gap-10 justify-center items-center sub-section-container"
    >
      <h2
        class="pageHeader"
        [innerHTML]="'privacyPolicyPage.title' | translate"
      ></h2>
      <div
        class="flex flex-col w-full justify-center items-start text-content-container"
      >
        <h4
          class="pageParagraph font-bold"
          [innerHTML]="'privacyPolicyPage.1.header' | translate"
        ></h4>
        <p
          class="pageParagraph font-light"
          [innerHTML]="'privacyPolicyPage.1.p1' | translate"
        ></p>

        <h4
          class="pageParagraph font-bold"
          [innerHTML]="'privacyPolicyPage.2.header' | translate"
        ></h4>
        <p
          class="pageParagraph font-light"
          [innerHTML]="'privacyPolicyPage.2.p1' | translate"
        ></p>
        <p
          class="pageParagraph font-light"
          [innerHTML]="'privacyPolicyPage.2.p2' | translate"
        ></p>

        <h4
          class="pageParagraph font-bold"
          [innerHTML]="'privacyPolicyPage.3.header' | translate"
        ></h4>
        <p
          class="pageParagraph font-light"
          [innerHTML]="'privacyPolicyPage.3.p1' | translate"
        ></p>

        <h4
          class="pageParagraph font-bold"
          [innerHTML]="'privacyPolicyPage.4.header' | translate"
        ></h4>
        <p
          class="pageParagraph font-light"
          [innerHTML]="'privacyPolicyPage.4.p1' | translate"
        ></p>
        <p
          class="pageParagraph font-light"
          [innerHTML]="'privacyPolicyPage.4.p2' | translate"
        ></p>

        <h4
          class="pageParagraph font-bold"
          [innerHTML]="'privacyPolicyPage.5.header' | translate"
        ></h4>
        <p
          class="pageParagraph font-light"
          [innerHTML]="'privacyPolicyPage.5.p1' | translate"
        ></p>
        <ul>
          <li
            class="pageParagraph font-light"
            [innerHTML]="'privacyPolicyPage.5.ul.li1' | translate"
          ></li>
          <li
            class="pageParagraph font-light"
            [innerHTML]="'privacyPolicyPage.5.ul.li2' | translate"
          ></li>
          <li
            class="pageParagraph font-light"
            [innerHTML]="'privacyPolicyPage.5.ul.li3' | translate"
          ></li>
          <li
            class="pageParagraph font-light"
            [innerHTML]="'privacyPolicyPage.5.ul.li4' | translate"
          ></li>
        </ul>
        <p
          class="pageParagraph font-light"
          [innerHTML]="'privacyPolicyPage.5.p2' | translate"
        ></p>

        <h4
          class="pageParagraph font-bold"
          [innerHTML]="'privacyPolicyPage.6.header' | translate"
        ></h4>
        <p
          class="pageParagraph font-light"
          [innerHTML]="'privacyPolicyPage.6.p1' | translate"
        ></p>

        <h4
          class="pageParagraph font-bold"
          [innerHTML]="'privacyPolicyPage.7.header' | translate"
        ></h4>
        <p
          class="pageParagraph font-light"
          [innerHTML]="'privacyPolicyPage.7.p1' | translate"
        ></p>

        <h4
          class="pageParagraph font-bold"
          [innerHTML]="'privacyPolicyPage.8.header' | translate"
        ></h4>
        <p
          class="pageParagraph font-light"
          [innerHTML]="'privacyPolicyPage.8.p1' | translate"
        ></p>

        <h4
          class="pageParagraph font-bold"
          [innerHTML]="'privacyPolicyPage.9.header' | translate"
        ></h4>
        <p
          class="pageParagraph font-light"
          [innerHTML]="'privacyPolicyPage.9.p1' | translate"
        ></p>

        <h4
          class="pageParagraph font-bold"
          [innerHTML]="'privacyPolicyPage.10.header' | translate"
        ></h4>
        <p
          class="pageParagraph font-light"
          [innerHTML]="'privacyPolicyPage.10.p1' | translate"
        ></p>

        <h4
          class="pageParagraph font-bold"
          [innerHTML]="'privacyPolicyPage.11.header' | translate"
        ></h4>
        <p
          class="pageParagraph font-light"
          [innerHTML]="'privacyPolicyPage.11.p1' | translate"
        ></p>

        <h4
          class="pageParagraph font-bold"
          [innerHTML]="'privacyPolicyPage.12.header' | translate"
        ></h4>
        <p
          class="pageParagraph font-light"
          [innerHTML]="'privacyPolicyPage.12.p1' | translate"
        ></p>

        <h4
          class="pageParagraph font-bold"
          [innerHTML]="'privacyPolicyPage.13.header' | translate"
        ></h4>
        <p
          class="pageParagraph font-light"
          [innerHTML]="'privacyPolicyPage.13.p1' | translate"
        ></p>
        <ul>
          <li
            class="pageParagraph font-light"
            [innerHTML]="'privacyPolicyPage.13.ul.li1' | translate"
          ></li>
          <li
            class="pageParagraph font-light"
            [innerHTML]="'privacyPolicyPage.13.ul.li2' | translate"
          ></li>
          <li
            class="pageParagraph font-light"
            [innerHTML]="'privacyPolicyPage.13.ul.li3' | translate"
          ></li>
          <li
            class="pageParagraph font-light"
            [innerHTML]="'privacyPolicyPage.13.ul.li4' | translate"
          ></li>
        </ul>
        <p
          class="pageParagraph font-light"
          [innerHTML]="'privacyPolicyPage.13.p2' | translate"
        ></p>
        <ul>
          <li
            class="pageParagraph font-light"
            [innerHTML]="'privacyPolicyPage.13.ul.li5' | translate"
          ></li>
          <li
            class="pageParagraph font-light"
            [innerHTML]="'privacyPolicyPage.13.ul.li6' | translate"
          ></li>
        </ul>
        <p
          class="pageParagraph font-light"
          [innerHTML]="'privacyPolicyPage.13.p3' | translate"
        ></p>

        <h4
          class="pageParagraph font-bold"
          [innerHTML]="'privacyPolicyPage.14.header' | translate"
        ></h4>
        <p
          class="pageParagraph font-light"
          [innerHTML]="'privacyPolicyPage.14.p1' | translate"
        ></p>
        <ul>
          <li
            class="pageParagraph font-light"
            [innerHTML]="'privacyPolicyPage.14.ul.li1' | translate"
          ></li>
          <li
            class="pageParagraph font-light"
            [innerHTML]="'privacyPolicyPage.14.ul.li2' | translate"
          ></li>
          <li
            class="pageParagraph font-light"
            [innerHTML]="'privacyPolicyPage.14.ul.li3' | translate"
          ></li>
        </ul>
        <p
          class="pageParagraph font-light"
          [innerHTML]="'privacyPolicyPage.14.p2' | translate"
        ></p>

        <h4
          class="pageParagraph font-bold"
          [innerHTML]="'privacyPolicyPage.15.header' | translate"
        ></h4>
        <p
          class="pageParagraph font-light"
          [innerHTML]="'privacyPolicyPage.15.p1' | translate"
        ></p>

        <h4
          class="pageParagraph font-bold"
          [innerHTML]="'privacyPolicyPage.16.header' | translate"
        ></h4>

        <table class="pageTable pageParagraph">
          <tbody class="divide-y divide-gray-300">
            <tr>
              <td class="font-semibold">
                {{ 'privacyPolicyPage.16.table.row1.col1' | translate }}
              </td>
              <td class="font-light">
                {{ 'privacyPolicyPage.16.table.row1.col2' | translate }}
              </td>
            </tr>
            <tr>
              <td class="font-semibold">
                {{ 'privacyPolicyPage.16.table.row2.col1' | translate }}
              </td>
              <td class="font-light">
                {{ 'privacyPolicyPage.16.table.row2.col2' | translate }}
              </td>
            </tr>
          </tbody>
        </table>

        <h4
          class="pageParagraph font-bold pt-8"
          [innerHTML]="'privacyPolicyPage.17.header' | translate"
        ></h4>
        <p
          class="pageParagraph font-light"
          [innerHTML]="'privacyPolicyPage.17.p1' | translate"
        ></p>

        <table class="pageTable pageParagraph">
          <thead>
            <tr class="divide-x divide-gray-300">
              <th class="p-4 text-left">
                {{ 'privacyPolicyPage.17.table.th.col1' | translate }}
              </th>
              <th class="p-4 text-left">
                {{ 'privacyPolicyPage.17.table.th.col2' | translate }}
              </th>
            </tr>
          </thead>
          <tbody class="font-light">
            <tr>
              <td>{{ 'privacyPolicyPage.17.table.row1.col1' | translate }}</td>
              <td>{{ 'privacyPolicyPage.17.table.row1.col2' | translate }}</td>
            </tr>
            <tr>
              <td>{{ 'privacyPolicyPage.17.table.row2.col1' | translate }}</td>
              <td>{{ 'privacyPolicyPage.17.table.row2.col2' | translate }}</td>
            </tr>
            <tr>
              <td>{{ 'privacyPolicyPage.17.table.row3.col1' | translate }}</td>
              <td>{{ 'privacyPolicyPage.17.table.row3.col2' | translate }}</td>
            </tr>
            <tr>
              <td>{{ 'privacyPolicyPage.17.table.row4.col1' | translate }}</td>
              <td>{{ 'privacyPolicyPage.17.table.row4.col2' | translate }}</td>
            </tr>
            <tr>
              <td>{{ 'privacyPolicyPage.17.table.row5.col1' | translate }}</td>
              <td>{{ 'privacyPolicyPage.17.table.row5.col2' | translate }}</td>
            </tr>
            <tr>
              <td>{{ 'privacyPolicyPage.17.table.row6.col1' | translate }}</td>
              <td>{{ 'privacyPolicyPage.17.table.row6.col2' | translate }}</td>
            </tr>
            <tr>
              <td>{{ 'privacyPolicyPage.17.table.row7.col1' | translate }}</td>
              <td>{{ 'privacyPolicyPage.17.table.row7.col2' | translate }}</td>
            </tr>            
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>
<app-end-footer></app-end-footer>
